var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Authenticator',{staticClass:"authenticator",attrs:{"to":_vm.to}})
}
var staticRenderFns = []

export { render, staticRenderFns }